var SELECTORS = {
    ROWCLASS: 'acp-be-editrow'
};
var i18n = {
    BULK_EDIT: ACP_Editing.i18n.bulk_edit.bulk_edit
};
var BulkEditRow = /** @class */ (function () {
    function BulkEditRow(BulkEdit) {
        this.BulkEdit = BulkEdit;
        this.Table = BulkEdit.Table;
        this.Middleware = BulkEdit.Middleware;
    }
    BulkEditRow.prototype.add = function () {
        var thead = this.Table.el.getElementsByTagName('thead')[0];
        var headers = thead.children[0].children;
        var row = document.createElement('tr');
        row.classList.add(SELECTORS.ROWCLASS);
        for (var i = 0; i < headers.length; i++) {
            var header = headers[i];
            var column = this.Table.Columns.get(header.id);
            var cell = document.createElement('td');
            cell.classList.add("column-" + header.id);
            if (header.id !== 'cb' && column.editable) {
                if (column.editable.hasOwnProperty('bulk_editable') && column.editable.bulk_editable === false) {
                    row.appendChild(cell);
                    continue;
                }
                cell.innerHTML = "<button class=\"button\">" + i18n.BULK_EDIT + "</button>";
                cell.column = column;
                this.initEvents(cell);
            }
            row.appendChild(cell);
        }
        this.Table.el.querySelector('tbody').insertAdjacentElement('afterBegin', row);
        this.refresh();
        return row;
    };
    BulkEditRow.prototype.remove = function () {
        var row = this.Table.el.querySelector("." + SELECTORS.ROWCLASS);
        if (row) {
            row.remove();
        }
    };
    BulkEditRow.prototype.initEvents = function (cell) {
        var _this = this;
        cell.querySelector('button').addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            _this.BulkEdit.onButtonTrigger(cell);
        }, true);
    };
    BulkEditRow.prototype.getRow = function () {
        return this.Table.el.querySelector("." + SELECTORS.ROWCLASS);
    };
    BulkEditRow.prototype.refresh = function () {
        var thead = this.Table.el.getElementsByTagName('thead')[0];
        var headers = thead.children[0].children;
        for (var i = 0; i < headers.length; i++) {
            var header = headers[i];
            var isHidden = header.classList.contains('hidden');
            var col = this.getRow().querySelector(".column-" + header.id);
            if (!col) {
                continue;
            }
            if (isHidden) {
                col.classList.add('hidden');
            }
            else {
                col.classList.remove('hidden');
            }
        }
    };
    return BulkEditRow;
}());
export default BulkEditRow;
